module.exports = __webpack_public_path__ + "img/11_2023_11_20.cdd67034.png";